import React from "react";
import { Header } from "../components/Header";
import { HomeRoute } from "./HomeRoute";
import { ArgumentRoute } from "./ArgumentRoute";

export function MainRoute({
  topics,
  heroAd,
  onSwapHero,
  activeTopic,
  onSelectTopic,
  onBackHome,
  feedAds,
  onSwapFeedAd,
  activeTab,
  onChangeTab,
  user,
  onOpenProfile,
  onGoHome,
  onOpenMessages,
  onOpenNotifications,
  onOpenNetwork,
  onOpenLegal,
  onOpenAdmin,
  unreadDm = 0,
  notifCount = 0,
}) {
  const isHome = activeTopic === null;
  return (
    <div
      className={`${isHome ? "min-h-[100dvh]" : "h-[100dvh] overflow-hidden"} bg-cream font-body flex flex-col`}
      id="top"
    >
      <Header
        user={user}
        onOpenProfile={onOpenProfile}
        onGoHome={onGoHome}
        onOpenMessages={onOpenMessages}
        onOpenNotifications={onOpenNotifications}
        onOpenNetwork={onOpenNetwork}
        onOpenLegal={onOpenLegal}
        onOpenAdmin={onOpenAdmin}
        unreadDm={unreadDm}
        notifCount={notifCount}
        showLegalMenu={true}
        showSearch={!isHome}
        showMobileSearch={true}
      />
      {isHome ? (
        <HomeRoute
          topics={topics}
          heroAd={heroAd}
          onSwapHero={onSwapHero}
          onSelectTopic={onSelectTopic}
        />
      ) : (
        <ArgumentRoute
          topics={topics}
          activeTopic={activeTopic}
          onSelectTopic={onSelectTopic}
          onBackHome={onBackHome}
          heroAd={heroAd}
          onSwapHero={onSwapHero}
          feedAds={feedAds}
          onSwapFeedAd={onSwapFeedAd}
          activeTab={activeTab}
          onOpenMessages={onOpenMessages}
          onChangeTab={onChangeTab}
          onOpenLegal={onOpenLegal}
          onOpenAdmin={onOpenAdmin}
          onGoHome={onGoHome}
        />
      )}
    </div>
  );
}
